export default "__VITE_ASSET__34c0b523__"